import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import { Home } from './Home';
import { Business } from './Business';
import { Accessibility } from './Accessibility';
import { Permitforuseexceeds } from './Permitforuseexceeds';
import About from './About';
import Contact from './Contact';
import { Websiteterms } from './Websiteterms';
import { customers } from './customers';
import { Layout } from './components/Layout';
import { NavigationBar } from './components/NavigationBar';
import Navigationdowen from './components/Navigationdowen';
import Screen from './components/Screen';
import HamburgerMenu from './components/Nav/HamburgerMenu';

import { AccessibilityWidget } from 'react-accessibility';
import FloatingWhatsApp from 'react-floating-whatsapp';
import CookieConsent from './CookieConsent';







class App extends Component {
  render() {
    return (
     
      <React.Fragment>
        <Router>
  
        < NavigationBar /> 
        <HamburgerMenu/>

          <Screen />
      
          <Switch>
            <Route exact path="/" component={Home} />
             <Route path="/Business" component={Business} />
            <Route path="/Accessibility" component={Accessibility} />
            <Route path="/Permitforuseexceeds" component={Permitforuseexceeds} />
            <Route path="/about" component={About} />
            <Route path="/contact " component={Contact} />
            <Route path="/customers " component={customers} />
            <Route path="/articles" component={Websiteterms} />
          </Switch>

         
         <AccessibilityWidget />
          <FloatingWhatsApp />
          <CookieConsent />

        </Router>

        <Navigationdowen />
      </React.Fragment>
      
         

    );
  }
}

export default App;






